import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPieChart3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPieChart3"><Path d="M11.25 12.3105L18.5186 19.5791C16.7678 21.0863 14.4914 22 12 22C6.47715 22 2 17.5228 2 12C2 6.72951 6.07754 2.41389 11.25 2.03027V12.3105Z" fill="currentColor"/><Path d="M21.5391 8.99121C21.8383 9.94084 22 10.9515 22 12C22 14.4914 21.0863 16.7678 19.5791 18.5186L13.334 12.2734L21.5391 8.99121Z" fill="currentColor"/><Path d="M12.75 2.03027C16.3725 2.29894 19.4567 4.49565 20.9805 7.59961L12.75 10.8916V2.03027Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPieChart3;
